export default "__VITE_ASSET__L32uGFmD__"